import React from 'react';
import {
  ThemeProvider as SCProvider,
  createGlobalStyle,
  keyframes,
  DefaultTheme,
} from 'styled-components/macro';
import baseTheme from './theme';

export function ThemeProvider({
  theme = {},
  children,
}: {
  theme?: Partial<DefaultTheme>;
  children: React.ReactNode;
}) {
  return <SCProvider theme={{ ...baseTheme, ...theme }}>{children}</SCProvider>;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px; 
  }

  input:-webkit-autofill {
    background-color: transparent !important;
  }
    
  .animation-rotate {
    animation: ${rotate} 2s linear infinite;
  }
`;
